import SpecialistServiceDetail from "@/components/SpecialistServiceDetail";

const WOMEN = "https://static.prod-images.emergentagent.com/jobs/67e85589-df3b-4949-9f26-d13809d545ec/images/b5f3654b9a06380b6b2ecf732a7e5c8d909325194c7d11171737f9e5bcb28f4b.jpeg";

export default function WomenCare() {
  return (
    <SpecialistServiceDetail
      testid="women-care-page"
      eyebrow="WOMEN CARE"
      title="Women Care"
      subtitle="Care for every stage of a woman's life."
      image={WOMEN}
      accent="#DB2777"
      box="#FCE7F0"
      aiPrompt="I'd like guidance on women's health."
      offerings={[
        "Gynaecology & menstrual health consultations",
        "Pregnancy, fertility and postnatal care",
        "Hormonal, thyroid & PCOS management",
        "Preventive screenings — breast, cervical & bone health",
        "Menopause and wellness support",
      ]}
    />
  );
}
